import { IModelEntity } from '@pit/core';
import { IDtoDepot } from './dto.depot.interface';
import { IDtoMandator } from './dto.mandator.interface';
import { IDtoUserRole } from './dto.user.role.interface';

export enum UserState {

    Created = 0,
    Registered = 1,
    Avtive = 2,
    Deactive = 3,
    Deleted = 4

}

export interface IDtoUser extends IModelEntity {

    firstName?: string;
    lastName?: string;
    number?: string;
    password?: string;
    passwordResetRequested?: boolean;
    token?: string;
    userName?: string;
    userNumber?: string;
    userState?: UserState;

    mandator?: IDtoMandator;

    depots?: IDtoDepot[];
    userRoles?: IDtoUserRole[];

    completeDescription?: string;
    completeDescriptionExt?: string;
    fullName?: string;
    fullNameExt?: string;
    isAdmin?: boolean;
    isAdminSuper?: boolean;
    isDispatcher?: boolean;
    isMobileUser?: boolean;
    isWebUser?: boolean;
    roleDescription?: string;

}
